// extracted by mini-css-extract-plugin
export default {"textLink":"AssessorManagementTable_textLink__1wiLa"};